import { DateString, urlDateFormat } from 'common/UrlDate';
import { first } from 'lodash';
import { DateTime } from 'luxon';

export interface IGetDefaultDeliveryDateArgs {
  availabilityDates: readonly DateTime[];
  availabilityInfo: readonly { dateTime: DateTime; isSoldOut: boolean }[];
  userDateFilters: DateString[];
  cartDeliveryDate: DateTime | undefined;
}

export function getDefaultDeliveryDate({
  availabilityDates,
  availabilityInfo,
  userDateFilters,
  cartDeliveryDate,
}: IGetDefaultDeliveryDateArgs): DateTime | undefined {
  const sortedAvailabilityDates = [...availabilityDates].sort();
  const sortedAvailabilityDatesExcludingSoldOut = sortedAvailabilityDates.filter(
    (availabilityDate) => !availabilityInfo.find(({ dateTime }) => availabilityDate.equals(dateTime))?.isSoldOut
  );
  // Pick the date that matches what was in redux store, this date may have passed an no longer available
  const dateTimeFromCartStore =
    cartDeliveryDate &&
    sortedAvailabilityDatesExcludingSoldOut.find(
      (dateTimeObject) => dateTimeObject.toMillis() === cartDeliveryDate.toMillis()
    );

  // Pick the first date that's the intersection between the user's date
  // filters and the shef's available days:
  const dateTimeFromUrl = sortedAvailabilityDatesExcludingSoldOut.find((dateTimeObject) =>
    userDateFilters.some((userPickedDate) => dateTimeObject.toFormat(urlDateFormat) === userPickedDate)
  );
  // If none of the user's filtered days are available, pick the first non sold out day:
  const firstNotSoldOutDateTime: DateTime | undefined = first(sortedAvailabilityDatesExcludingSoldOut);
  // Else, fall back to the first day the shef had available, even though they're sold out:
  const firstDateTime = first(sortedAvailabilityDates);

  return dateTimeFromCartStore ?? dateTimeFromUrl ?? firstNotSoldOutDateTime ?? firstDateTime; // fallback for unavailable shefs
}
